import { render } from "./LiveChatHome.vue?vue&type=template&id=3aad89db&scoped=true"
import script from "./LiveChatHome.vue?vue&type=script&lang=js"
export * from "./LiveChatHome.vue?vue&type=script&lang=js"

import "./LiveChatHome.vue?vue&type=style&index=0&id=3aad89db&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aad89db"]])

export default __exports__